/* eslint-disable newline-per-chained-call */
import { z } from 'zod';

const OneOffENSchema = z.object({
    serviceIds: z
        .string({
            required_error: 'Please select a service',
        })
        .min(1),
});

type OneOffENFormValues = z.infer<typeof OneOffENSchema>;

export { OneOffENSchema, OneOffENFormValues };
